import React from "react";

export function CheckBoldIcon({ color = "#06E77B", ...props }) {
  return (
  <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg" stroke={color} {...props}>
    <path d="M2 7.80645L8.12766 14L20 2" strokeWidth="4"/>
  </svg>
  );
}
